/**
 * fetchUserDocFromDB.js
 */

import { doc, getDoc } from "firebase/firestore";
import { Users } from "../assets/DatabaseCollections";
import { db } from "../config/firebase";

/**
 * Fetches user data from Firestore Users collection.
 * @param {String} userID           -   Firebase Doc ID of the user
 * @returns {Object|null}           -   User document data or null if not found.
 */
export const getUserDataFromDB = async (userID) => {
    try {
        const userRef = doc(db, Users, userID);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
            return { uid: userSnap.id, ...userSnap.data() };
        } else {
            console.warn("User not found in DB:", userID);
            return null;
        }
    } catch (error) {
        console.error("Error fetching user data:", error);
        return null;
    }
};